/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { FormControl } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import {
  format,
  isValid,
  isAfter,
  getYear,
  getMonth,
} from 'date-fns';
import MonthCalendar from '../MonthCalendar';
import styles from './styles.scss';

const FORMAT = {
  zh: 'YYYY-MM-DD',
  en: 'DD/MM/YYYY',
};

const defaultProps = {
  date: new Date(),
  view: 'date',
  closeOnSelect: true,
  disabled: d => isAfter(d, new Date()),
  anchor: null,
};

const propTypes = {
  date: React.PropTypes.instanceOf(Date),
  view: React.PropTypes.oneOf([
    'year',
    'month',
    'date',
  ]),
  onSelect: React.PropTypes.func.isRequired,
  locale: React.PropTypes.string.isRequired,
  disabled: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.instanceOf(Date)),
    React.PropTypes.func,
  ]),
  closeOnSelect: React.PropTypes.bool,
  anchor: React.PropTypes.instanceOf(Date),
};

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.date,
      view: props.view,
      disabled: props.disabled,
      anchor: props.anchor,
    };
    this.id = `datepicker_${Number(Math.random() * 10000).toFixed(0)}`;
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.clickToBlur = this.clickToBlur.bind(this);
    this.inputChanged = false;
  }

  componentDidMount() {
    $('body').click(this.clickToBlur);
  }

  componentWillReceiveProps(nextProps) {
    const { date, view, disabled, anchor } = nextProps;
    if (date !== this.props.date) {
      this.setState({ date });
    }
    if (view !== this.props.view) {
      this.setState({ view });
    }
    if (disabled !== this.props.disabled) {
      this.setState({ disabled });
    }
    if (anchor !== this.props.anchor) {
      this.setState({ anchor });
    }
  }

  componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  }

  clickToBlur(e) {
    let blurred = true;
    $(e.target).parents().each((idx, elem) => {
      if (elem.id === this.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({ showOverlay: false });
    }
  }

  handleInputFocus() {
    this.setState({ showOverlay: true });
  }

  handleInputChange(e) {
    const value = e.target.value.trim();
    this.setState({ value });
    const date = new Date(value);
    if (isValid(date)) {
      this.inputChanged = true;
      this.setState({ date });
    }
  }

  handleInputBlur() {
    if (this.inputChanged) {
      const { onSelect } = this.props;
      const { date } = this.state;
      onSelect(date);
      this.inputChanged = false;
    }
  }

  handleSelect(date) {
    const { onSelect, closeOnSelect } = this.props;
    this.setState({ value: '' });
    onSelect(date);
    if (closeOnSelect) {
      this.setState({ showOverlay: false });
    }
  }

  renderView() {
    const { view = 'date', date, disabled, anchor } = this.state;

    if (view === 'date') {
      return (
        <MonthCalendar
          year={getYear(date)}
          month={getMonth(date)}
          selected={date}
          onSelect={this.handleSelect}
          disabled={disabled}
          anchor={anchor}
        />
      );
    }
    return null;
  }

  renderOverlay() {
    if (this.state.showOverlay) {
      return (
        <div className={styles.overlay}>
          <div className={styles.container}>
            {this.renderView()}
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { locale } = this.props;
    const { date, value = '' } = this.state;
    return (
      <div id={this.id} className={styles.datepicker}>
        <FormControl
          bsClass="aisz-form-control-f"
          type="text"
          placeholder={FORMAT[locale]}
          value={value || format(date, FORMAT[locale])}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          onChange={this.handleInputChange}
        />
        {this.renderOverlay()}
      </div>
    );
  }
}

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;


const mapStateToProps = state => ({
  locale: state.intl.locale,
});
export default injectIntl(connect(mapStateToProps, null)(DatePicker));




// WEBPACK FOOTER //
// ./src/components/DatePicker/index.jsx